import { transitionTravelUgNextOfKinForm } from '../../../actions/travelUg/nextOfKin';
import { getNextOfKinForm } from '../../../selectors/travelUg/nextOfKin';
import { FIELD_STATUS } from '../../../reducers/status';

export const nextOfKinFormRules = (store, next, action) => {
    const result = next(action);
    const nextOfKinForm = getNextOfKinForm(store.getState());
    const nextOfKinFormValid = validateNextOfKinFormDetails(nextOfKinForm);
    const formAction = nextOfKinFormValid
        ? transitionTravelUgNextOfKinForm.formValid()
        : transitionTravelUgNextOfKinForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateNextOfKinFormDetails = (formFields) => {
    return (
        formFields.relationship &&
        formFields.relationship.status === FIELD_STATUS.VALID &&
        formFields.firstName &&
        formFields.firstName.status === FIELD_STATUS.VALID &&
        formFields.email &&
        formFields.email.status === FIELD_STATUS.VALID &&
        formFields.phoneNumber &&
        formFields.phoneNumber.status === FIELD_STATUS.VALID &&
        formFields.postalAddress &&
        formFields.postalAddress.status === FIELD_STATUS.VALID
    );
};
